module.exports = __webpack_public_path__ + "img/telemedicine.8099941b.svg";